<template>
  <nav>
    <v-navigation-drawer app v-model="drawer" temporary right :width="getWidth">
      <v-list-item>
        <v-list-item-icon class="mr-4 cursor-pointer" @click="drawer = !drawer">
          <v-icon>mdi-arrow-left</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Filter</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-container>
        <v-row>
          <slot></slot>
        </v-row>
      </v-container>
    </v-navigation-drawer>
  </nav>
</template>
<script>
export default {
  props: ['openDrawer'],
  computed: {
    getWidth () {
      return this.$vuetify.breakpoint.mdAndDown ? '100%' : '30%'
    }
  },
  watch: {
    openDrawer () {
      this.drawer = this.openDrawer
    },
    drawer (val) {
      if (!val) {
        this.$emit('update:value', val)
      }
    }
  },
  data () {
    return {
      data: '',
      drawer: this.openDrawer,
    }
  },
}
</script>
<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
